import { differenceInMinutes, DisplayDate } from 'owa-datetime';
import { DateRange } from 'owa-datetime-utils';

export default function isDateInDateRangeUsingMinutes(
    dateRange: DateRange,
    date: DisplayDate
): boolean {
    return (
        differenceInMinutes(dateRange.start, date) <= 0 &&
        differenceInMinutes(dateRange.end, date) >= 0
    );
}
